jQuery.noConflict();
(function($) {
  $('.slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 2,

    responsive: [{
      breakpoint: 768,
      settings: {
        fade: true,
        slidesToShow: 1
      }
    }]
  });

  $('.archive-container__gallery').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,


    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  $('.archive-container__gallery').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,


    responsive: [
      {
        breakpoint: 480,
        settings: {
          dots: true,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  lightbox.option({
    'wrapAround': true,
    'albumLabel': "%1 / %2",
    'resizeDuration': 200,
    'positionFromTop': 30
  });
})(jQuery);
